import {UserSesionModel} from "../auth/helpers/user-sesion.model";

export function createSignInUserSession(email: string,
                                        accessToken: string,
                                        refreshToken: string,
                                        idToken: string,
                                        baseUrl: string,
                                        stateParams: string | null): UserSesionModel {
    return {
        email,
        accessToken,
        refreshToken,
        idToken,
        baseUrl,
        stateParams
    };
}

export function saveSignInUserStorage(user: UserSesionModel) {
    sessionStorage.setItem("logInUserSession", JSON.stringify(user));
}

export function readSignInUserStorage(): UserSesionModel | null {
    let jsonUserSession = sessionStorage.getItem("logInUserSession") as string;
    if (jsonUserSession == null) {
        return null;
    }
    return JSON.parse(jsonUserSession) as UserSesionModel;
}
